








































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Dialog from '@/components/Dialog.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';

@Component({
  components: {
    GenericButton,
    ConfirmButton,
    Dialog,
  },
})
export default class ProjectEdit extends Vue {
  @Action private addUsersAsync: any;
  @Action private createProjectAsync: any;
  @Action private updateProjectAsync: any;
  @Getter private projects!: object;
  @Getter private login: any;
  @Prop() private project: any;
  @Prop() private openDialog!: boolean;
  @Prop() private editing!: boolean;
  @Getter private getProjectById!: any;
  @Getter private users: any;

  private userList: Array<{text: string, value: number}> = [];
  private isSaving: boolean = false;

  public created() {
    this.$nextTick(() => {
      (this.$refs.form as any).resetValidation();
    });
    this.load();
  }

  private async load() {
    const apiJobs: Array<Promise<void>> = [];
    apiJobs.push(this.addUsersAsync({
        take: 0,
        skip: 0,
        sort: null,
        desc: null,
        filters: [],
        searchNames: null,
        projectId: null,
      }));
    await Promise.all(apiJobs);
    this.userList = this.users.map((user: any) => {
      return {text: this.getUserName(user), value: user.id};
    });
  }

  private async save() {
    this.isSaving = true;
    try {
      if (this.project.id > 0) {
        this.updateProjectAsync({
          id: Number(this.project.id),
          payload: {
            name: this.project.name,
            user_id: this.project.user_id,
          },
        });
      } else {
        this.createProjectAsync({
            name: this.project.name,
            user_id: this.project.user_id || this.login.details.id,
        });
      }
    } catch (e) {
      throw e;
    } finally {
      this.$emit('closeDialog');
      this.isSaving = false;
    }
  }

  private getUserName(user: any) {
    if (!user.first_name.length && !user.last_name.length) {
      return user.email;
    } else {
      return user.first_name + ' ' + user.last_name;
    }
  }
}
